module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1703"
  }, [_c('span', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("“Write ")]), _vm._v("to Your Unknown Friends”")]), _vm._v(" "), _c('p', {
    staticClass: "C1704"
  }, [_c('em', [_vm._v("—Jeff Gundy")])]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("This is for Bob. He’s a good guy, likes")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("to fly fish, records each catch, where")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("he caught it, the weather, type of fly,")]), _vm._v(" "), _c('p', {
    staticClass: "C1606"
  }, [_vm._v("time of day. He tosses everything back.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("This is for Tanya. She’s a single mom")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("with three kids. She works behind")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("the counter in the post office, knows")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("everyone in town. Years ago she")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("threw away the “Return to Sender.")]), _vm._v(" "), _c('p', {
    staticClass: "C1606"
  }, [_vm._v("Address Unknown” stamp.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("This is for Ted. Ted sells cars.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("He wishes cars with fins would")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("come back. He knows gas mileage")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("matters. But “You don’t see")]), _vm._v(" "), _c('p', {
    staticClass: "C1606"
  }, [_vm._v("mileage when a car drives by.”")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("This is for Kenny. He never made it")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("past the sixth grade. In the winter,")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("he plows driveways, shovels walks.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("The rest of the year he paints houses,")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("mows lawns, hauls junk. Each morning")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("he buys a paper, reads it over a cup")]), _vm._v(" "), _c('p', {
    staticClass: "C1606"
  }, [_vm._v("of coffee, black, and does the crossword.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("This is for Ann. In her backyard, she")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("has a perennial garden, best in town,")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("more than a hundred different plants.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("She has four greyhounds and a parakeet.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("Wherever she goes, she wears a hat.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_c('span', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("This ")]), _vm._v("is for Martha. She talks to")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("sparrows. She tries to tell them")]), _vm._v(" "), _c('p', {
    staticClass: "C1606"
  }, [_vm._v("something they’ve never heard.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("This is for Sammy. He’s always late.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("He loves to play blackjack. He’s")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("no good at counting cards. He wants")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("to own a motorcycle and ride it")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("to places he’s never been—Toledo,")]), _vm._v(" "), _c('p', {
    staticClass: "C1606"
  }, [_vm._v("Jacksonville, Los Angeles, Maine.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("Today there’s no one around.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("Too bad. It’s a good day")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("to call some friends, see if")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("they’d like to come over, shoot")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("the breeze, have some pizza, maybe")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("watch an old movie on TV.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c5f58f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07__Write_t.vue
// module id = 75
// module chunks = 0